/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ENStratergicPlan20262030Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="2026-2030 Strategic Plan"
              description={
               <>
               <h4>Elections Nova Scotia Continues Strategic Direction</h4>
                  <br />
                  <p>Elections Nova Scotia (ENS) has released a strategic plan that will guide the organization over the next four years (2026-2030). </p>
                  <br />
                  <p>Following the Provincial General Election in 2024, ENS reviewed its objectives and sought input to help improve electoral services for Nova Scotians. Consultation to shape ENS’s strategic direction included feedback from staff and returning officers as well as input from stakeholders, such as registered political parties, IDEAS partners (Inclusion Diversity, Equity and Accessibility), and the public. </p>
                  <br />
                  <p>This refreshed strategic plan builds on the foundation established in ENS’s 2022-2026 Strategic Plan, reaffirming goals while incorporating enhancements informed by lessons learned in the 42nd Provincial General Election in 2024. ENS plans to stay the course and continue to modernize the democratic process, enabling voters to access services and vote in ways that suit their needs. The 2026-2030 plan shows ENS remains committed to improving electoral services for Nova Scotians, building relationships with stakeholders and partners, and supporting election workers. </p>
                  <br />
                  <p>Please click here to view the <u><a href="/files/AnnualAndOtherReports/2026_2030_ENS_Strategic_Plan_FINAL.pdf">2026-2030 Strategic Plan.</a></u> </p>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ENStratergicPlan20262030Information;
